import { deleteEmptyObj, formatCST } from '@/utils/utils'
const state = {
  page: 1,
  total: 0,
  limit: 10,
  activeTab: '0',
  unit_name: '',
  applicant_name: '',
  created_at_from: null,
  created_at_to: null
}

const actions = {
  // 获取学校数据
  async schoolApplyGetData ({ state, commit }, playload) {
    const data = {
      applicant_name: state.applicant_name,
      created_at_from: state.created_at_from && formatCST(state.created_at_from),
      created_at_to: state.created_at_to && formatCST(state.created_at_to),
      unit_name: state.unit_name
    }
    deleteEmptyObj(data)
    const res = await API.post(`/edu/zone/channel/agent/school/applicant/list?page=${state.page}&limit=${state.limit}`, data)
    commit('setState', {
      module: 'schoolApply',
      key: 'total',
      value: res.data.total
    })
    return res
  }
}

const mutations = {
  schoolApplyInit (state) {
    state.page = 1
    state.total = 0
    state.limit = 10
    state.unit_name = ''
    state.applicant_name = ''
    state.created_at_from = null
    state.created_at_to = null
  }
}

export default {
  state,
  actions,
  mutations
}
